export default "__VITE_ASSET__DKYMGqxu__"